import { Typography, IconButton, Box, Tooltip, Grid } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import "./PreviewPanel.css";
const PreviewPanel = ({
  json,
  onRefresh,
  title,
}: {
  json: string;
  onRefresh?: () => void;
  title?: string;
}) => {
  const lines = json.split("\n");

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography variant="caption" color="text.secondary" className="uio">
            Request SQL
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} md={11}>
        <Box
          sx={{
            display: "flex",
            background: "#f9f9f9",
            borderBottom: "1px solid rgba(0,0,0,0.04)",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary" />
        </Box>

        <Box
          sx={{
            display: "flex",
            fontFamily: "monospace",
            fontSize: "12px",
            lineHeight: 1.5,
            color: "text.primary",
            maxHeight: 300,
            overflow: "auto",
          }}
        >
          {/* gutter (line numbers) */}
          <Box
            sx={{
              background: "#fafafa",
              borderRight: "1px solid rgba(0,0,0,0.04)",
              px: 1.25,
              py: 1,
              textAlign: "right",
              userSelect: "none",
              color: "rgba(0,0,0,0.5)",
            }}
          >
            <pre style={{ margin: 0 }}>
              {lines.map((_, idx) => (
                <div key={idx} style={{ height: "2em" }}>
                  {idx + 1}
                </div>
              ))}
            </pre>
          </Box>

          {/* code content */}
          <Box sx={{ p: 1, flex: 1 }}>
            <pre
              style={{
                margin: 0,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontSize: 16,
                fontFamily: "roboto",
                minHeight: "600px",
              }}
            >
              {json}
            </pre>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={1} sx={{ mb: 0 }}>
        <Typography variant="h6" sx={{ fontSize: 20, flex: 1, mb: 2 }}>
          {title}
        </Typography>
        <Tooltip title="Refresh preview">
          <IconButton
            size="small"
            onClick={onRefresh}
            sx={{
              color: "#9c27b0", // purple like screenshot
              ml: 1,
            }}
            data-tracker="389"
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default PreviewPanel;
